import { MachineObjectType } from "../../../contexts/MachineContext";

interface FieldsAndValuesInterface{
  label:string;
  type:string;
  value:keyof MachineObjectType;
  placeholder?:string
}

interface FormatType {
  label: string;
  value: string;
  dimensions: {
    dim1: string;
    dim2?: string;
    length: string;
  };
}

export const formatOptions: FormatType[] = [
  {
    label: 'Redondo',
    value: 'redondo',
    dimensions: {
      dim1: 'Diâmetro',
      length: 'Comprimento'
    }
  },
  {
    label: 'Disco',
    value: 'disco',
    dimensions: {
      dim1: 'Diâmetro',
      length: 'Espessura'
    }
  },
  {
    label: 'Quadrado',
    value: 'quadrado',
    dimensions: {
      dim1: 'Largura',
      dim2: 'Altura',
      length: 'Comprimento'
    }
  },
  {
    label: 'Retangular',
    value: 'retangular',
    dimensions: {
      dim1: 'Largura',
      dim2: 'Altura',
      length: 'Comprimento'
    }
  },
  {
    label: 'Chapa',
    value: 'chapa',
    dimensions: {
      dim1: 'Largura',
      dim2: 'Altura',
      length: 'Comprimento'
    }
  },
  {
    label: 'Lingote',
    value: 'lingote',
    dimensions: {
      dim1: 'Largura',
      dim2: 'Altura',
      length: 'Comprimento'
    }
  },
  {
    label: 'Anel',
    value: 'anel',
    dimensions: {
      dim1: 'Diâmetro interno',
      dim2: 'Diâmetro externo',
      length: 'Espessura'
    }
  },
  {
    label: 'Tubo',
    value: 'tubo',
    dimensions: {
      dim1: 'Diâmetro interno',
      dim2: 'Parede',
      length: 'Comprimento'
    }
  },
];

export const getFieldsByFormat = (format: string): FieldsAndValuesInterface[] => {
  const baseFields: FieldsAndValuesInterface[] = [
    {
      label: 'Identificação',
      type: 'text',
      value: 'identification'
    },
    {
      label: 'Modelo',
      type: 'text',
      value: 'model'
    },
    {
      label: 'Formato',
      type: 'select',
      value: 'format'
    },
    {
      label: 'Custo por hora',
      type: 'cash',
      value: 'costPerHour',
      placeholder: 'R$ 00,00'
    },
    {
      label: 'Unidade de medida',
      type: 'select',
      value: 'unitOfMeasure'
    },
    {
      label: 'Capacidade miníma',
      type: 'text',
      value: 'productionCapacityMin'
    },
    {
      label: 'Capadidade máxima',
      type: 'text',
      value: 'productionCapacityMax'
    },
    {
      label: 'Peso da máquina (kg)',
      type: 'text',
      value: 'weight'
    },
    {
      label: 'Altura (m)',
      type: 'text',
      value: 'height'
    },
    {
      label: 'Largura (m)',
      type: 'text',
      value: 'width'
    },
    {
      label: 'Comprimento (m)',
      type: 'text',
      value: 'length'
    },
    {
      label: 'Última manutenção',
      type: 'date',
      value: 'lastMaintenance'
    },
    {
      label: 'Próxima manutenção',
      type: 'date',
      value: 'nextMaintenance'
    },
  ];

  if (!format) {
    return baseFields;
  }

  const selectedFormat = formatOptions.find(f => f.value === format);
  if (!selectedFormat) {
    return baseFields;
  }

  // Campos dinâmicos baseados no formato
  const dynamicFields: FieldsAndValuesInterface[] = [];
  
  // Adiciona campo para primeira dimensão
  dynamicFields.push({
    label: selectedFormat.dimensions.dim1,
    type: 'text',
    value: 'width' // Usando width como dim1
  });

  // Adiciona campo para segunda dimensão se existir
  if (selectedFormat.dimensions.dim2) {
    dynamicFields.push({
      label: selectedFormat.dimensions.dim2,
      type: 'text',
      value: 'height' // Usando height como dim2
    });
  }

  // Adiciona campo para comprimento/espessura
  dynamicFields.push({
    label: selectedFormat.dimensions.length,
    type: 'text',
    value: 'length'
  });

  return baseFields.map(field => {
    if (field.value === 'width' || field.value === 'height' || field.value === 'length') {
      const dynamicField = dynamicFields.find(df => df.value === field.value);
      return dynamicField || field;
    }
    return field;
  });
};

export const fieldsAndValues: FieldsAndValuesInterface[] = [
  {
    label: 'Identificação',
    type: 'text',
    value: 'identification'
  },
  {
    label: 'Modelo',
    type: 'text',
    value: 'model'
  },
  {
    label: 'Formato',
    type: 'select',
    value: 'format'
  },
  {
    label: 'Custo por hora',
    type: 'cash',
    value: 'costPerHour',
    placeholder: 'R$ 00,00'
  },
  {
    label: 'Unidade de medida',
    type: 'select',
    value: 'unitOfMeasure'
  },
  {
    label: 'Capacidade miníma',
    type: 'text',
    value: 'productionCapacityMin'
  },
  {
    label: 'Capadidade máxima',
    type: 'text',
    value: 'productionCapacityMax'
  },
  {
    label: 'Peso da máquina (kg)',
    type: 'text',
    value: 'weight'
  },
  {
    label: 'Altura (m)',
    type: 'text',
    value: 'height'
  },
  {
    label: 'Largura (m)',
    type: 'text',
    value: 'width'
  },
  {
    label: 'Comprimento (m)',
    type: 'text',
    value: 'length'
  },
  {
    label: 'Última manutenção',
    type: 'date',
    value: 'lastMaintenance'
  },
  {
    label: 'Próxima manutenção',
    type: 'date',
    value: 'nextMaintenance'
  },
]